export default __webpack_public_path__ + "static/media/person_3.1d9b21ca.png";